export const BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_mobile_bx585_saved_search_favorites_merge';
export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';
export const PERS_MOBILE_RECS_IN_FAVORITES_V2_EXPERIMENT = 'aud_mobile_bx933_recs_in_favorites_v2';

export const EXPERIMENTS = [
  BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
  PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
  PERS_MOBILE_RECS_IN_FAVORITES_V2_EXPERIMENT,
];
